import { render, staticRenderFns } from "./create-room.vue?vue&type=template&id=903f51ae&"
import script from "./create-room.vue?vue&type=script&lang=ts&"
export * from "./create-room.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports